import React from 'react';
import bitmap from '../../../public/images/bitmap.jpg';
import { sectionBlocks } from '../constants';
import { useTranslation } from '../../../src/i18n';
import TitledDescription from '../../../components/TitledDescription';
import GoToLink from '../../../components/GoToLink';
import styles from './LinkSections.module.scss';

function LinkSections() {
  const { t } = useTranslation('NS_APP_GLOBALS');

  return (
    <div className={styles.sectionBg} style={{ backgroundImage: `url(${bitmap})` }}>
      <div className={styles.titleContainer}>
        <h2 className={styles.viewTitle}>{t('operabase.general.FN_OPERAPROFESSIONAL')}</h2>
      </div>
      <div className={styles.viewItemContainer}>
        {sectionBlocks.map(item => (
          <div className={styles.viewItem} key={item.id}>
            <TitledDescription
              title={t(item.title)}
              color="default"
              descColor="black"
              size="customLargeTitle"
              description={t(item.description)}
              tagName="h3"
            />
            <GoToLink linkText={t(item.linkText)} linkProps={item.linkProps} size="large" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default LinkSections;
